import { Icon, TIconVariant } from '../icon'
import { useStyles } from './styles'

export type Tab = {
  icon: TIconVariant
  label: string
  value: number
}

export type AppTabsProps = {
  tabs: Tab[]
  activeValue: number
  onChange: (value: number) => void
}

export const AppTabs = (props: AppTabsProps) => {
  const { classes } = useStyles()
  const { tabs, activeValue, onChange } = props
  return (
    <div className={classes.root}>
      {tabs.map((tab) => (
        <div
          key={tab.value}
          data-isactive={activeValue === tab.value}
          className={classes.tab}
          onClick={() => onChange(tab.value)}
        >
          <Icon
            view={tab.icon}
            width={20}
          />
          <span>{tab.label}</span>
        </div>
      ))}
    </div>
  )
}
